import React, { useContext } from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { MyLimitsFormButton } from "@components/buttons";
import { DepositAndLossLimitSubmit, LimitSubmit } from "@data-types";
import { DepositContext } from "@state/context/payment/DepositContext";
import { LimitType } from "@utils/limits/limitType";
import { observer } from "mobx-react";

export default observer(function DepositLimitFooter() {
	const depositStore = useContext(DepositContext);

	const { handleSubmit } = useFormContext();

	const { t } = useTranslation("my-limits");

	if (
		depositStore.depositLimitStore.limitData?.userLimits[0]
			?.gamingLimitDuration.abrv === LimitType.DAILY_LIMIT ||
		depositStore.depositLimitStore.limitData?.userLimits[0]
			?.gamingLimitDuration.abrv === LimitType.WEEKLY_LIMIT
	) {
		return (
			<div className="popup__footer">
				<div>
					<MyLimitsFormButton
						type="button"
						className="btn--med btn--accent form__actions__btn"
						onClick={() => {
							handleSubmit((data: LimitSubmit) => {
								depositStore.depositLimitStore.submitDailyOrWeeklyForm(
									data
								);
							})();
						}}
						btnText={t("COMMON.SAVE_BUTTON")}
					/>
				</div>

				<button
					type="button"
					className="popup__btn btn btn--med btn--primary--inverted"
					onClick={depositStore.depositLimitStore.deactivateAllSteps}
				>
					{t("COMMON.CANCEL")}
				</button>
			</div>
		);
	}

	if (
		depositStore.depositLimitStore.limitData?.userLimits[0]
			?.gamingLimitDuration.abrv === LimitType.MONTHLY_LIMIT
	) {
		return (
			<div className="popup__footer">
				<div>
					<MyLimitsFormButton
						type="button"
						className="btn--med btn--accent form__actions__btn"
						onClick={() => {
							handleSubmit((data: DepositAndLossLimitSubmit) => {
								depositStore.depositLimitStore.submitMonthlyLimitForm(
									data
								);
							})();
						}}
						btnText={t("my-limits:SUBMIT_APPLICATION")}
					/>
				</div>

				<button
					type="button"
					className="popup__btn btn btn--med btn--primary--inverted"
					onClick={depositStore.depositLimitStore.deactivateAllSteps}
				>
					{t("COMMON.CANCEL")}
				</button>
			</div>
		);
	}

	return null;
});
